export default __webpack_public_path__ + "static/media/shutterstock_334586228_DESCARGAS.b864963b.webp";